// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_9e1425b4d3--checkbox--Y2Njc","box":"_9e1425b4d3--box--FHmxp","invalid":"_9e1425b4d3--invalid--uf33E","disabled":"_9e1425b4d3--disabled--djeBi"};